import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createDeviceStore } from "./device";
import { Store } from "./store.types";

export const useStore = create<Store>()(
  devtools((...a) => ({
    ...createDeviceStore(...a),
  }))
);
